import React from 'react';
import { useTranslation } from 'react-i18next';

interface TextAlignDropdownProps {
  value: 'left' | 'center' | 'right';
  onChange: (align: 'left' | 'center' | 'right') => void;
  className?: string;
  label?: string;
  showLabel?: boolean;
}

const TextAlignDropdown: React.FC<TextAlignDropdownProps> = ({
  value,
  onChange,
  className,
  label,
  showLabel = true
}) => {
  const { t } = useTranslation('thumbnailEditor');
  
  return (
    <div style={{ flex: 1 }}>
      {showLabel && (
        <label style={{
          display: 'block',
          marginBottom: '8px',
          fontSize: '14px',
          fontWeight: '500',
          color: '#b0b0b0'
        }}>
          {label || t('thumbnailEditor.textTab.textAlign')}
        </label>
      )}
      <select
        value={value}
        onChange={(e) => onChange(e.target.value as 'left' | 'center' | 'right')}
        className={className}
        style={{
          width: '100%',
          padding: '8px 12px',
          backgroundColor: '#2a2a2a',
          border: '1px solid rgba(255, 255, 255, 0.1)',
          borderRadius: '6px',
          color: 'white',
          fontSize: '14px',
          outline: 'none',
          height: '36px',
          cursor: 'pointer'
        }}
      >
        <option value="left">{t('thumbnailEditor.textTab.alignLeft')}</option>
        <option value="center">{t('thumbnailEditor.textTab.alignCenter')}</option>
        <option value="right">{t('thumbnailEditor.textTab.alignRight')}</option>
      </select>
    </div>
  );
};

export default TextAlignDropdown;
